<template>
  <div class="ResumeDialog">
    <el-dialog
      :visible.sync="dialogVisible"
      width="560px"
      custom-class="resume_dialog"
      :before-close="handleClose"
    >
      <div class="resume_title">投递简历</div>
      <div class="resume_job">
        应聘岗位：<span>{{ job ? job.title : "" }}</span>
        <span class="resume_job_salary" v-if="job">{{ job.salary }}</span>
      </div>
      <el-form ref="resumeForm" :model="form" :rules="rules" label-position="top">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="附件简历" prop="fileList">
          <el-upload
            class="resume_upload"
            action="#"
            :auto-upload="false"
            :limit="3"
            accept=".pdf,.doc,.docx"
            :file-list="fileList"
            :on-change="handleFileChange"
            :on-remove="handleFileRemove"
            :on-exceed="handleExceed"
          >
            <el-button size="small" class="upload_btn">选择附件</el-button>
          </el-upload>
          <div class="upload_tip">支持 pdf / doc / docx，单个不超过 10MB，最多 3 个</div>
        </el-form-item>
      </el-form>
      <div class="resume_footer">
        <el-button class="resume_cancel" @click="handleClose">取 消</el-button>
        <el-button class="resume_submit" :loading="loading" @click="handleSubmit">投 递</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { saveJobResumeApi, uploadResumeFileApi } from "@/api/index";

export default {
  name: "ResumeDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    job: {
      type: Object,
      default: null,
    },
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (/^1[3-9]\d{9}$/.test(value)) {
        return callback();
      }
      callback("请输入正确的手机号");
    };
    var checkEmail = (rule, value, callback) => {
      const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
      if (regEmail.test(value)) {
        return callback();
      }
      callback("请输入合法邮箱");
    };
    return {
      loading: false,
      fileList: [],
      form: {
        name: "",
        phone: "",
        email: "",
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: checkEmail, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    loginPromptSeq() {
      return this.$store.getters["auth/loginPromptSeq"];
    },
  },
  watch: {
    //每次打开清空上一轮内容
    visible(val) {
      if (val) {
        this.form.name = "";
        this.form.phone = "";
        this.form.email = "";
        this.fileList = [];
        this.$nextTick(() => {
          if (this.$refs.resumeForm) this.$refs.resumeForm.clearValidate();
        });
      }
    },
    loginPromptSeq() {
      if (this.visible) this.handleClose();
    },
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    //附件校验：格式 + 大小，不合法的从列表剔除
    handleFileChange(file, fileList) {
      const ext = file.name.split(".").pop().toLowerCase();
      const okType = ["pdf", "doc", "docx"].includes(ext);
      const okSize = file.size / 1024 / 1024 <= 10;
      if (!okType || !okSize) {
        this.$message.error(!okType ? "仅支持 pdf / doc / docx 格式" : "附件大小不能超过 10MB");
        this.fileList = fileList.filter((f) => f.uid !== file.uid);
        return;
      }
      this.fileList = fileList;
    },
    handleFileRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleExceed() {
      this.$message.warning("最多上传 3 个附件");
    },
    handleSubmit() {
      this.$refs.resumeForm.validate((valid) => {
        if (!valid) return;
        if (this.fileList.length === 0) {
          this.$message.warning("请上传附件简历");
          return;
        }
        this.loading = true;
        this.uploadAttachments().then((files) => {
          return saveJobResumeApi({
            jobId: this.job ? this.job.id : null,
            name: this.form.name,
            phone: this.form.phone,
            email: this.form.email,
            files: JSON.stringify(files),
          });
        }).then((res) => {
          this.loading = false;
          if (res.code !== 0) {
            this.$message.error(res.msg || "投递失败");
            return;
          }
          this.$message.success(res.msg || "投递成功");
          this.$emit("success", {
            jobId: this.job ? this.job.id : null,
            jobTitle: this.job ? this.job.title : "",
            name: this.form.name,
            phone: this.form.phone,
            email: this.form.email,
            attachments: this.fileList.map((f) => f.name),
          });
          this.handleClose();
        }).catch((err) => {
          this.loading = false;
          this.$message.error((err && err.msg) || "投递失败");
        });
      });
    },
    //先把本地附件传到文件服务，再把 name + url 一并提交给投递接口
    uploadAttachments() {
      return Promise.all(this.fileList.map((file) => {
        if (file.url) {
          return Promise.resolve({ name: file.name, url: file.url });
        }
        if (!file.raw) {
          return Promise.reject({ msg: file.name + " 无法读取，请重新选择" });
        }
        return uploadResumeFileApi(file.raw).then((res) => {
          if (res.code !== 0 || !res.data || !res.data.url) {
            return Promise.reject({ msg: res.msg || (file.name + " 上传失败") });
          }
          file.url = res.data.url;
          return { name: file.name, url: res.data.url };
        });
      }));
    },
  },
};
</script>

<style scoped>
.ResumeDialog >>> .resume_dialog {
  border-radius: 8px;
}

.ResumeDialog >>> .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ResumeDialog >>> .resume_dialog {
  margin: 0 !important;
}

.ResumeDialog >>> .resume_dialog .el-dialog__header {
  padding: 0;
}

.ResumeDialog >>> .resume_dialog .el-dialog__body {
  padding: 28px 32px 24px;
}

.resume_title {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  text-align: center;
  padding-bottom: 16px;
}

.resume_job {
  font-size: 14px;
  color: #999999;
  padding-bottom: 12px;
}

.resume_job span {
  color: #1b63a7;
  font-weight: 600;
}

.resume_job_salary {
  margin-left: 8px;
  color: #f56c6c !important;
}

.ResumeDialog >>> .el-form-item {
  margin-bottom: 16px;
}

.ResumeDialog >>> .el-form--label-top .el-form-item__label {
  padding-bottom: 4px;
  line-height: 20px;
}

.upload_btn {
  background: #1b63a7;
  color: #fff;
  border: none;
}

.upload_btn:hover {
  background: #2968bd;
  color: #fff;
}

.upload_tip {
  font-size: 12px;
  color: #999999;
  padding-top: 4px;
}

.resume_footer {
  text-align: center;
  padding-top: 8px;
}

.resume_cancel {
  width: 110px;
  height: 40px;
  border-radius: 8px;
}

.resume_submit {
  width: 110px;
  height: 40px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #2968bd, #1b63a7);
  border: none;
  border-radius: 8px;
  margin-left: 16px;
}

.resume_submit:hover {
  box-shadow: 0 2px 8px rgba(27, 99, 167, .35);
}
</style>


// WEBPACK FOOTER //
// src/views/components/ResumeDialog.vue